import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { Produit } from '../../../models/Produit';
import { PTR_LENGTH } from '../../../constante/produits';
import { padZerosLeft } from '../../../commons/helpers/StringHelper';

export interface IPTRCard {
    data: Produit
    handleCardClick: any
}

export default function PTRCard({ data, handleCardClick }: IPTRCard) {
    return (
        <Card sx={{ minWidth: 300, m: 1, maxWidth: 300 }}>
            <CardActionArea
                onClick={() => handleCardClick(data.prod_num)}
            >
                <CardMedia
                    sx={{ height: 140, objectFit: 'contain' }}
                    image={data.prod_web ? `https://cdn.tanguay.ca/images/products/1024px/${data.prod_num}.jpg?iv=3` : 'https://cdn.tanguay.ca/images/products/1024px/empty_photo.jpg'}
                    title="Produit"
            
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {padZerosLeft(data.prod_num, PTR_LENGTH)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Code: {data.act_cd}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Fini: {data.fini}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Categorie: {data.cat_cd}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Departement: {data.dept_cd}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Modele: {data.mod_cd}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}